import React, { useMemo } from "react";
import { Card, CardBody, CardHeader, Row, Col } from "reactstrap";

const ActivityChart = ({ data = [] }) => {
    // Calcular total e percentuais
    const { activities, total } = useMemo(() => {
        const t = data.reduce((sum, a) => sum + (a.count || 0), 0);
        const items = data.map(a => ({
            ...a,
            percentage: t > 0 ? ((a.count / t) * 100).toFixed(1) : "0.0"
        }));
        return { activities: items, total: t };
    }, [data]);

    // Gerar conic-gradient dinâmico
    const conicGradient = useMemo(() => {
        if (activities.length === 0) return "#e9ecef";
        let currentDeg = 0;
        const segments = activities.map(a => {
            const deg = (parseFloat(a.percentage) / 100) * 360;
            const start = currentDeg;
            currentDeg += deg;
            return `${a.color} ${start.toFixed(2)}deg ${currentDeg.toFixed(2)}deg`;
        });
        return `conic-gradient(${segments.join(", ")})`;
    }, [activities]);

    // Sem dados
    if (data.length === 0) {
        return (
            <Card className="border-0 shadow-sm h-100" style={{ borderRadius: "4px" }}>
                <CardHeader className="bg-white border-0 pt-4 px-4 pb-0">
                    <h6 className="text-uppercase fw-bold m-0 text-primary" style={{ fontSize: "11px", letterSpacing: "1px" }}>Alunos por Atividade</h6>
                </CardHeader>
                <CardBody className="p-4 d-flex align-items-center justify-content-center" style={{ minHeight: "200px" }}>
                    <div className="text-center text-muted">
                        <i className="mdi mdi-chart-donut mdi-48px mb-2 d-block" style={{ opacity: 0.3 }}></i>
                        <p className="mb-0" style={{ fontSize: "13px" }}>Nenhuma matrícula registrada</p>
                    </div>
                </CardBody>
            </Card>
        );
    }

    return (
        <Card className="border-0 shadow-sm h-100" style={{ borderRadius: "4px" }}>
            <CardHeader className="bg-white border-0 pt-4 px-4 pb-0">
                <div className="d-flex justify-content-between align-items-center">
                    <h6 className="text-uppercase fw-bold m-0 text-primary" style={{ fontSize: "11px", letterSpacing: "1px" }}>Alunos por Atividade</h6>
                    <span className="badge bg-soft-primary text-primary" style={{ fontSize: "11px" }}>
                        {total} alunos
                    </span>
                </div>
            </CardHeader>
            <CardBody className="p-4 pt-4 mt-2">
                <Row className="align-items-center">
                    <Col sm={7}>
                        <Row>
                            {activities.map((item, idx) => (
                                <Col xs={6} key={idx} className="mb-3">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <span 
                                                className="rounded-circle me-2" 
                                                style={{ width: "8px", height: "8px", backgroundColor: item.color, flexShrink: 0 }} 
                                            />
                                            <span style={{ fontSize: "12px", fontWeight: "600", color: "#74788d" }}>{item.name}</span>
                                        </div>
                                        <span style={{ fontSize: "13px", fontWeight: "700", color: "#343a40" }}>{item.percentage}%</span>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </Col>
                    <Col sm={5} className="d-flex justify-content-center">
                        <div className="position-relative" style={{ width: "135px", height: "135px" }}>
                            {/* Doughnut Chart dinâmico */}
                            <div 
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    borderRadius: "50%",
                                    background: conicGradient
                                }}
                            />
                            <div 
                                className="position-absolute shadow-sm d-flex align-items-center justify-content-center"
                                style={{
                                    top: "22.5%",
                                    left: "22.5%",
                                    width: "55%",
                                    height: "55%",
                                    backgroundColor: "white",
                                    borderRadius: "50%"
                                }}
                            >
                                <span style={{ fontSize: "18px", fontWeight: "700", color: "#343a40" }}>{total}</span>
                            </div>
                        </div>
                    </Col>
                </Row>
            </CardBody>
        </Card>
    );
};

export default ActivityChart;
